import axios from 'services/axios';
import { COMPANY } from 'services/consts';

import AppLogger from 'utils/AppLogger';
import { store } from 'utils/configureStore';

const fetchRemainingAmount = async () => {
	return await axios
		.post(COMPANY.GET_REMAINING_AMOUNT)
		.then((response) => {
			if (response.status === 200) {
				store.dispatch({
					type: 'user/setUserDetails',
					payload: response.data
				});

				return response.data;
			} else {
				AppLogger.error(response);
			}
		})
		.catch((error) => {
			AppLogger.error(error);
		});
};

export default fetchRemainingAmount;
